import React from 'react';
import CardSection from '../../Shared/CardSection';
import { FaInfoCircle } from "react-icons/fa";

const LifeValuesSection = ({ model, portalSettings }) => {

    const Tooltip = ({ text, position = "right", className = "" }) => (<span className={`ltooltip-container ${className}`}> <FaInfoCircle className="ltooltip-icon" /> <span className={`ltooltip-text ${position}`}>{text}</span> </span>);

    const {
        box1Label,
        box1Value,
        box1Tooltip,
        box2Label,
        box2Value,
        box2Tooltip,
        box3Label,
        box3Value,
        box3Tooltip,
        maxLoan,
        currLoan,
        currAvailable,
        loanDate,
        finalAVWPending,
        cSV,
        yTDInterest,
        loanIntRate,
        termLength
    } = model.lifeValues;

    const {
        polType,
        productName,
        productType,
        plan,
        statusDesc,
        issueDate,
        termDate,
        qualType,
        issAge,
        paidToDate
    } = model.policyInfo;

    const cleanValue = rawValue => {
        if (rawValue == null) return 0;
        // Remove $ and commas & then parse
        const numeric = parseFloat(rawValue.toString().replace(/[$,]/g, ""));
        return isNaN(numeric) ? 0 : numeric;
    };

    const myChartData = [
        { label: "Premiums", value: cleanValue(model.policyInfo.premiumSum) },
        { label: "Interest", value: "N/A" },
        { label: "Premium Bonus", value: cleanValue(0) },
    ];

    return (
        <div className="container container-section custom-width" id="values-container">
            {/* Top Row: Summary Cards */}
            <div className="flex-row">
                {[
                    { label: box1Label, value: box1Value }, // face amount
                    { label: box2Label, value: box2Value }, // death bene
                    { label: box3Label, value: box3Value } // loan balance
                ].map(({ label, value }, idx) => (
                    <div key={idx} className="policy-card small-card">
                        <div className="card">
                            <div className="card-body">
                                <h6>{label}

                                    {(idx === 0 && model.lifeValues.box1Tooltip) && (
                                        <Tooltip text={model.lifeValues.box1Tooltip} />
                                    )}
                                    {(idx === 1 && model.lifeValues.box2Tooltip) && (
                                        <Tooltip text={model.lifeValues.box2Tooltip} />
                                    )}
                                    {(idx === 2 && model.lifeValues.box3Tooltip) && (
                                        <Tooltip text={model.lifeValues.box3Tooltip} className="right-edge" />
                                    )}

                                </h6>
                                <h3 className="bold value">{value}</h3>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Second Row: Card Sections */}
            <div className="flex-row">
                {/* Contract Details */}
                <CardSection
                    title="Contract Details"
                    blocks={[
                        { label: "Plan:", value: model.policyInfo.productType },
                        { label: "Issue Age:", value: issAge },
                        { label: "Issue Date:", value: model.policyInfo.issueDate },
                        { label: "Paid To Date:", value: model.policyInfo.paidToDate },
                        { label: "Policy Status:", value: model.policyInfo.statusDesc },
                        { label: "Issue State:", value: model.policyInfo.issueState },
                        { label: "Loan Interest Rate:", value: loanIntRate }
                    ]}
                />
            </div>
        </div>
    );
};

export default LifeValuesSection;
